/**
 * The user's Vault calendars, for choosing where meeting invites go (the email
 * settings "Calendar invites" picker and the Add-to-calendar menu). Read-only
 * here — calendars are managed in the calendar arche.
 */

import { useQuery } from '@tanstack/react-query';
import { api, type CalendarCollectionDetail } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export function useInviteCalendars(enabled = true) {
  return useQuery<CalendarCollectionDetail[]>({
    queryKey: queryKeys.calendarCollections.all,
    queryFn: async () => (await api.listCalendarCollections()).calendars,
    staleTime: 60_000,
    enabled,
  });
}
